import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'

import { StateSwitcher } from 'containers/misc'
import {
  awardStatePermissions,
  awardStateSuperiorPermissions,
  awardStateVerifierPermissions
} from 'models/awards'
import { ACTIVITY_STATE_CATEGORIES, ORGANIZATION_MODES, PROGRESS_STATES } from 'constants/enums'
import { ACTIVITY_SECTIONS, LEVELS } from '../../../../constants/enums'

export default class AwardState extends Component {
  static propTypes = {
    awardId: PropTypes.number,
    awardState: PropTypes.object,
    awardMode: PropTypes.object,
    changeAwardState: PropTypes.func.isRequired,
    componentAwardSignoff: PropTypes.object,
    componentRegApproval: PropTypes.object,
    componentRegAssignment: PropTypes.object,
    componentOfflineAwardSignoff: PropTypes.object,
    componentAwardOfficeSignoff: PropTypes.object,
    isSuperior: PropTypes.bool,
    isVerifier: PropTypes.bool,
    award: PropTypes.object
  }

  static defaultProps = {
    awardState: {},
    componentModal: null
  }


  getActivitySectionValidationData = (activityList, section) => {
    const sectionActivityList = activityList && activityList.filter(a => get(a, 'activitySection.value') === section)

    const assessmentResults = sectionActivityList && sectionActivityList.map(a => get(a, 'isAssessmentPositive'))

    const isAssessmentPositive = !assessmentResults.includes(false)

    let isCompleted

    if(sectionActivityList && sectionActivityList.length > 0) {
      isCompleted = (get(sectionActivityList[0], 'completed') / 3600) >= (get(sectionActivityList[0], 'total') / 3600)
    }

    return { isAssessmentPositive, isCompleted }
  }

  isAjAssessmentPositive = ajList => {
    const assessmentResults = ajList && ajList.map(aj => get(aj, 'isAssessmentPositive'))

    return !assessmentResults.includes(false)
  }

  render() {
    const {
      awardState,
      awardMode,
      changeAwardState,
      awardId,
      componentRegApproval,
      componentAwardSignoff,
      componentRegAssignment,
      componentAwardOfficeSignoff,
      componentOfflineAwardSignoff,
      isSuperior,
      isVerifier,
      award
    } = this.props
    let states = {}

    const activities = get(award, 'activities')
    const ajs = get(award, 'adventurousJourneys')
    const physicalValidationData = this.getActivitySectionValidationData(activities, ACTIVITY_SECTIONS.physical.id)
    const skillValidationData = this.getActivitySectionValidationData(activities, ACTIVITY_SECTIONS.skills.id)
    const serviceValidationData = this.getActivitySectionValidationData(activities, ACTIVITY_SECTIONS.service.id)

    let isAssessmentPositive = get(physicalValidationData, 'isAssessmentPositive') &&
        get(skillValidationData, 'isAssessmentPositive') &&
        get(serviceValidationData, 'isAssessmentPositive') &&
        this.isAjAssessmentPositive(ajs)

    if(get(award, 'awardLevel.value') === LEVELS.GOLD.value) {
      isAssessmentPositive = isAssessmentPositive && get(award, 'residentialProject.isAssessmentPositive')
    }

    const isCompleted = get(physicalValidationData, 'isCompleted') &&
        get(skillValidationData, 'isCompleted') &&
        get(serviceValidationData, 'isCompleted')


    const validationData = { isAssessmentPositive, isCompleted }

    const displayAwardSignoffOfflineModal =
      get(awardMode, 'value') === ORGANIZATION_MODES.offline.id &&
      get(awardState, 'value') === PROGRESS_STATES.awardInProgress.id

    const ModalComponent = displayAwardSignoffOfflineModal
      ? componentOfflineAwardSignoff
      : null

    if (isSuperior) {
      states = awardStateSuperiorPermissions({
        componentRegApproval,
        componentAwardSignoff,
        componentRegAssignment,
        componentAwardOfficeSignoff
      })
    } else if (isVerifier) {
      states = awardStateVerifierPermissions({
        componentRegApproval,
        componentAwardSignoff,
        componentRegAssignment,
        componentAwardOfficeSignoff
      })
    } else {
      states = awardStatePermissions({
        componentRegApproval,
        componentAwardSignoff
      })
    }

    return (
      <StateSwitcher
        id={awardId}
        state={awardState}
        states={states}
        changeState={changeAwardState}
        ModalContent={ModalComponent}
        validationData={validationData}
        stateType={ACTIVITY_STATE_CATEGORIES.award.id}
      />
    )
  }
}
